import type { RealWedding } from '../types/landing'

export const realWeddings: RealWedding[] = [
  {
    tag: 'Adventure at every turn',
    couple: 'Ariana & Tracy',
    description:
      'Golden-hour portraits on the old railroad tracks, a weekend of friends and family under the pines, and a celebration built around fun first.',
    image: 'https://cdn.magicpatterns.com/uploads/6qQMcPaGqYhxqde3CVu97T/Screenshot_2026-09-30_at_9.22.06_AM.png',
  },
  {
    tag: 'Forest wedding magic',
    couple: 'Joan & Kyle',
    description:
      'A forest ceremony beneath the towering pines, a petal-filled send-off, and a wedding weekend so stunning it landed in BRIDES.',
    image: 'https://cdn.magicpatterns.com/uploads/dA3ZXxzzWdKdkQaDeC19wu/0902_Joan_Sbera_and_Kyle_Pecorino_-_Peyton_Rainey_Photography_-_Ceremony_(134)_2.jpg',
  },
  {
    tag: 'A whimsical dream',
    couple: 'Sarah & Cory',
    description:
      'Sunset views over the river canyon, a floral gown made for the mountains, and a day where every detail felt effortless.',
    image: 'https://cdn.magicpatterns.com/uploads/xpN6o9kuHBucTZzt2ouCdw/sarah__cory.webp',
  },
]
